if (!customElements.get('fp-addon')) {
  class FPAddon extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.fp-pdp-addon__cb');
      this.checkbox?.addEventListener('change', () => this.toggle());
    }

    async toggle() {
      const variantId = Number(this.dataset.variantId);
      if (!variantId) return;
      this.checkbox.disabled = true;
      try {
        if (this.checkbox.checked) {
          await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
        } else {
          await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(variantId), quantity: 0 }),
          });
        }
        if (window.SLIDECART_UPDATE) window.SLIDECART_UPDATE();
        document.querySelectorAll('cart-items, cart-drawer-items').forEach((el) => el.onCartUpdate?.());
        document.dispatchEvent(new CustomEvent('fp-addon:changed', { detail: { variantId } }));
      } catch (e) {
        this.checkbox.checked = !this.checkbox.checked;
      } finally {
        this.checkbox.disabled = false;
      }
    }
  }
  customElements.define('fp-addon', FPAddon);
}
